export default "__VITE_ASSET__D12B4B$W__"